<template>
    <div class="aipage">
      <extraPage :content="content"></extraPage>
    </div>
</template>
<script>
import extraPage from '@/components/extraPage.vue'
/* eslint-disable */
export default {
    components: {
        extraPage,
    },
    data() {
        return {
          content:{
            bannerTitle: require("@/assets/images/bussiness/maas/maasTitle.png"),
            bannerSmallTitle: '从模型训练到推理部署的全流程高效协同，为用户提供一站式的 AI 开发体验',
            productOverviewTitle: '深度融合国产芯片适配与异构算力调度的全栈AI平台',
            productOverviewContent: '集大模型开发、算法训练与部署、多模态应用构建于一体，覆盖数据采集标注、模型开发训练、评估转换至云端/边缘端一键部署的全流程闭环。',
            productOverviewImg: require("@/assets/images/bussiness/maas/maas_wrapbg5.png"),
            productArchitectureImg: require("@/assets/images/bussiness/maas/maas_wrapbg11.png"),
            productArchitectureImg2: require("@/assets/images/bussiness/maas/maas_wrapbg12.png"),
            productCapacityImg: require("@/assets/images/bussiness/maas/maas_wrapbg13.png"),
            aiContentList: [
                { title: '教育科研与教学实践', wrapPic: require("@/assets/images/bussiness/maas/maas_wrapbg1.png"), content:'集成大模型构建、训练与应用全流程，支持知识库与智能体开发，降低AI教学门槛，助力科研创新' },
                { title: '工业智能与生产优化', wrapPic: require("@/assets/images/bussiness/maas/maas_wrapbg2.png"), content:'实现数据治理与AI模型沉淀，赋能产线自动化、安全巡检等工业场景' },
                { title: '医疗健康与公共服务', wrapPic: require("@/assets/images/bussiness/maas/maas_wrapbg3.png"), content:'高效处理医疗影像、病历数据，加速疾病诊断模型训练与实时推理应用' },
                { title: '城市应急与公共安全', wrapPic: require("@/assets/images/bussiness/maas/maas_wrapbg4.png"), content:'整合城市摄像头资源，通过AI视觉实现森林防火、水务监测、工程安全等场景的智能预警与应急调度' },
            ],
            productGoodsList: [
                { title: '异构芯片全适配', wrapPic: require("@/assets/images/bussiness/maas/titleIcon1.png"), content:'自研智能引擎无缝兼容沐曦/海光/寒武纪多种国产芯片，自动优化算子性能损耗＜15%' },
                { title: '全流程建模闭环', wrapPic: require("@/assets/images/bussiness/maas/titleIcon2.png"), content:'打通「数据清洗-分布式训练-模型压缩-端侧部署」全链条，支持千卡集群协同训练' },
                { title: '百模即训即用', wrapPic: require("@/assets/images/bussiness/maas/titleIcon3.png"), content:'预置近百个工业级预训练模型（覆盖CV/LLM/多模态），支持百亿参数模型微调' },
                { title: '云边端一键部署', wrapPic: require("@/assets/images/bussiness/maas/titleIcon4.png"), content:'自适应生成ONNX / TensorRT / MLU等多种格式，设备部署时效＜3分钟，支持远程监控与热更新' },
                { title: '零代码智能体工坊', wrapPic: require("@/assets/images/bussiness/maas/titleIcon5.png"), content:'可视化工作流引擎集成多种功能组件，5分钟构建决策型AI Agent并支持在线调试与版本迭代' },
            ],
            productCapacityList:[
                { title:'用户数据实时采集与预处理', content:'实现流式采集、异构接入、智能清洗、多版本回溯与多模态融合，构建端到端实时数据处理链。' },
                { title:'在线数据标注与管理', content:'多模态标注模板+团队协作/AI双模式，支持全流程数据管理' },
                { title:'AI辅助智能标注', content:'OBB/分割/视频目标智能标注，实时质检与跨模态适配' },
                { title:'大模型开箱即用', content:'异构算力自适应，零代码接入与训推实时监控' },
                { title:'零编码大模型精调', content:'千亿参数大模型可视化微调、参数高效调优 、精度-效率平衡点智能推荐' },
                { title:'多模预训练模型仓库', content:'100+LLM/CV模型，无缝对接开源生态' },
                { title:'图形化的模型一键式部署', content:'多格式模型自动转换，端边云协同推理监控' },
                { title:'AI智能体工厂', content:'多模态编排引擎、可视化API治理' },
            ],
            caseList: [
                { title: '南京某高校AI实验室', wrapPic: require("@/assets/images/bussiness/maas/co_wrapbg9.png"), content:"教、培、训、推、用一体化异构算力实验室，接入城市和校园实景数据，将生产融入实训，相互成就" },
                { title: '青海智算中心', wrapPic: require("@/assets/images/bussiness/maas/co_wrapbg10.png"), content:"训、推、用一体化平台，提供全方位的AI建模解决方案"  },
            ]
          }
      }
    },
}
</script>